export default __webpack_public_path__ + "static/media/searchError.f120cf68.svg";